/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpTypeDisplay = "DEFAULT" | "NOT_LISTED" | "UNPURCHASABLE" | "%future added value";
export type PdpSharedAffirm_item$ref = any;
export type PdpSharedAffirm_item = {
    readonly affirmDisplayInfo: {
        readonly showAffirmPromo: boolean | null;
    } | null;
    readonly pdpTypeDisplay: PdpTypeDisplay | null;
    readonly pricing: {
        readonly totalAmount: {
            readonly convertedAmounts: {
                readonly USD: number | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": PdpSharedAffirm_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedAffirm_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": "affirmDisplayInfo",
            "name": "displayInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemDisplayInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showAffirmPromo",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "pdpTypeDisplay",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "pricing",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemPricing",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "totalAmount",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "convertedAmounts",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ConvertedAmounts",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "USD",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '8bb1a149f2356342f419ceaf9f7cb111';
export default node;
